(function(AddToCart, $) {
  var $addToCartButtons = $('.add-to-cart-js'),
    $bundleModal = $('.modal-overlay-bg.product-bundle'),
    $checkoutSwap = $('.no-thanks a', $bundleModal),
    goto = '/cart/',
    $completeBundle = $('.js-complete-bundle'),
    $window = $(window);

  var windowWidth = $window.width();

  var updateQuantity = function(self) {
    var $scope = $(self).parents('.BVA-add-to-cart'),
      currentInput = $scope.find('.qty-counter'),
      currentQty = currentInput.attr('value'),
      newQty = parseInt(currentQty) + parseInt($(self).data('change-by'));

    if (newQty <= 1) {
      newQty = 1;
    }

    $('input.qty-counter', $scope).attr('value', newQty);
    $('.add-to-cart', $scope).attr('data-quantity', newQty);
  };

  var addItemsToCart = function(self) {
    var quantity = $(self).attr('data-quantity'),
      variantID = $(self).attr('data-variant-id');

    CartJS.addItem(
      variantID,
      quantity,
      {},
      {
        success: function(data, textStatus, jqXHR) {
          fbq('track', 'AddToCart');
          // $addToCartButtons.html('<span>Added!</span>');
        },

        error: function(jqXHR, textStatus, errorThrown) {
          window.alert(
            "Sorry, we're unable to do that.\n" +
              JSON.parse(jqXHR.responseText).description
          );
        }
      }
    );
  };

  //Sets the floating ATC based on currently selected product
  var setFloatingAtcVariant = function() {
    var currentProductSelected = $('.product-selection__product.is-selected');
    var selectedVarID = currentProductSelected.data('variant-id');
    var bundle = currentProductSelected.data('bundle');
    var preorder = currentProductSelected.data('preorder');
    var promoitem = currentProductSelected.data('promo-item');

    $('.floating-cart-btn').attr('data-variant-id', selectedVarID);
    $('.floating-cart-btn').attr('data-bundle', bundle);
    $('.floating-cart-btn').attr('data-preorder', preorder);

    if (preorder === 'enabled') {
      $('.floating-cart-btn .add-to-cart').text('Pre-order Now');
    } else {
      $('.floating-cart-btn .add-to-cart').text('Add To Cart');
    }

    if (promoitem) {
      $('.floating-cart-btn').attr('data-promo-item', promoitem);
    } else {
      $('.floating-cart-btn').removeAttr('data-promo-item');
    }
  };

  // Funciton To Add Promo Item (In this case fender for XR)
  var addPromoItem = function(variantID) {
    CartJS.addItem(variantID, 1, {},
      {
        error: function(jqXHR, textStatus, errorThrown) {
          window.alert(
            "Sorry, we're unable to do that.\n" +
              JSON.parse(jqXHR.responseText).description
          );
        }
      }
    );
  };

  var bindUIActions = function() {
    /* QTY CHNAGE */
    $('.number-clicker .changer').click(function() {
      updateQuantity(this);
    });

    /* ADD TO CART*/

    $addToCartButtons.click(function(event) {
      if ($('#product-select').length) {
        $(this).attr('data-variant-id', $('#product-select').val());
      }

      goto = $(this).attr('href');
      event.preventDefault();
      event.stopPropagation();

      $checkoutSwap.each(function() {
        $(this).attr('href', goto);
      });

      $completeBundle.each(function() {
        $(this).data('goto', goto);
      });

      addItemsToCart(this);
      if ($('.product-bundler').length > 0) {
        $bundleModal
          .addClass('active')
          .find('.modal-outer')
          .addClass('active');
        $('body, html').addClass('no-scroll');
        fbq('track', 'AddToCart');
      } else {
        $(document).on('cart.requestComplete', function(event, cart) {
          AddToCart.goTo(goto);
        });
      }
    });

    $('.product-selection__product').on('click', function() {
      if ($window.width() <= 740) {
        $(this).addClass('is-selected');
        $(this)
          .siblings('.product-selection__product')
          .removeClass('is-selected');
        var variantId = $(this).attr('data-variant-id');
        var bundleName = $(this).attr('data-bundle-modal');

        // Set the ATC Button Text
        if ($(this).data('preorder') == 'enabled') {
          $('.product-select__atc-btn.mobile-atc')
            .attr('data-bundle-modal', bundleName)
            .attr('data-variant-id', variantId)
            .attr('data-cart-variant-id', variantId)
            .text('Pre-Order Now');
        } else {
          $('.product-select__atc-btn.mobile-atc')
            .attr('data-bundle-modal', bundleName)
            .attr('data-variant-id', variantId)
            .attr('data-cart-variant-id', variantId)
            .text('Add To Cart');
        }

        //NOTE: HACKY NEED TO MAKE THIS DYNAMIC
        if (variantId == '28241812369') {
          $('.product-select__mobile .karna-pricing').text('$91');
        } else {
          $('.product-select__mobile .karna-pricing').text('$109');
        }
        setFloatingAtcVariant();
      }
    });

    // Floating Cart Button Add To Cart
    $('.floating-cart-btn.product-btn').on('click', function() {
      var productVariantId = $(this).data('variant-id');
      var bundler = $(this).data('bundle');
      var preorder = $(this).data('preorder');
      var promoitem = $(this).data('promo-item');

      goto = $(this).data('goto');

      $checkoutSwap.each(function() {
        $(this).attr('href', goto);
      });

      $completeBundle.each(function() {
        $(this).data('goto', goto);
      });

      CartJS.addItem(productVariantId, 1, {}, {
        success: function(data, textStatus, jqXHR) {
          fbq('track', 'AddToCart');
        },
        error: function(jqXHR, textStatus, errorThrown) {
          window.alert(
            "Sorry, we're unable to do that.\n" +
              JSON.parse(jqXHR.responseText).description
          );
        }
      });

      if (promoitem) {
        var promoObj = {
          promoItem: promoitem,
          promoProduct: productVariantId
        };

        localStorage.setItem('promo-item', JSON.stringify(promoObj));

        //Add Promo Item
        addPromoItem(promoitem);
      }

      //Show bundle modal
      if (bundler === 'enabled') {
        $bundleModal
          .addClass('active')
          .find('.modal-outer')
          .addClass('active');
        $('body, html').addClass('no-scroll');
        fbq('track', 'AddToCart');
      } else {
        $(document).on('cart.requestComplete', function(event, cart) {
          AddToCart.goTo(goto);
        });
      }
    });

    // Product Select Add to Cart
    $('.js-add-to-cart').on('click', function() {
      var productHandle;
      if ($window.width() <= 740) {
        var productOptions = $(this).closest('.product-selection__options');
        var options = productOptions.find('.product-selection__product');
        var productVariantId = '';
        var bundler = '';
        var promoitem = '';

        options.each(function(i, el) {
          var $productSelected = $(el);
          if ($productSelected.hasClass('is-selected')) {
            productHandle = $productSelected.attr('data-bundle-modal');
            productVariantId = $productSelected.data('variant-id');
            bundler = $productSelected.data('bundle');
            promoitem = $productSelected.data('promo-item');
          }
        });
      } else {
        var $product = $(this).closest('.product-selection__product');
        var productVariantId = $product.data('variant-id');
        var bundler = $product.data('bundle');
        var promoitem = $product.data('promo-item');
      }

      goto = $(this).data('goto');

      $checkoutSwap.each(function() {
        $(this).attr('href', goto);
      });

      $completeBundle.each(function() {
        $(this).data('goto', goto);
      });

      if (promoitem) {
        var promoObj = {
          promoItem: promoitem,
          promoProduct: productVariantId
        };

        localStorage.setItem('promo-item', JSON.stringify(promoObj));

        //Add Promo Item
        addPromoItem(promoitem);
      }

      //Show bundle modal
      if (bundler === 'enabled') {
        productHandle = productHandle || $(this)
          .closest('.product-selection__product')
          .attr('data-bundle-modal');
        $modal = $bundleModal.filter(
          '[data-bundle-modal="' + productHandle + '"]'
        );
        $modal
          .addClass('active')
          .find('.modal-outer')
          .addClass('active');
        $('body, html').addClass('no-scroll');
        fbq('track', 'AddToCart');
      } else {
        CartJS.addItem(
          productVariantId,
          1,
          {},
          {
            success: function(data, textStatus, jqXHR) {
              fbq('track', 'AddToCart');
              AddToCart.goTo(goto);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              window.alert(
                "Sorry, we're unable to do that.\n" +
                  JSON.parse(jqXHR.responseText).description
              );
            }
          }
        );
      }
    });
  };

  AddToCart.goTo = function(href, ms) {
    var wait = typeof ms == 'number' ? ms : 500;
    return window.setTimeout(function() {
      window.location.href = goto;
    }, wait);
  };

  AddToCart.init = function() {
    bindUIActions();
    setFloatingAtcVariant();
  };
})((window.AddToCart = window.AddToCart || {}), jQuery);
